import React, { useContext, useEffect } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { CollectionContext } from "../Contexts/CollectionContext";
import { useParams } from "react-router-dom";
import Loading from "../pages/Loading";
import ReactGA from "react-ga";
import Aos from "aos";
import "aos/dist/aos.css";

ReactGA.pageview(window.location.pathname + window.location.search);


const Collections = () => {
  const { id } = useParams();
  const { collection, fetchCollectionsByCategory, loading, error } = useContext(CollectionContext);

  useEffect(() => {
    fetchCollectionsByCategory(id);
  }, [id]);

  useEffect(() => {
    Aos.init({ duration: 100 });
    Aos.refresh()
  }, []);

  return (
    <div>
      <NavBar />
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-white">
        <img
          src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_2000/sawa26_hdoyvj.webp"
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-10"></div>
        <div className="relative z-20 text-center px-4 sm:px-6 lg:px-8" data-aos="fade-up" data-aos-duration="2000">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold mb-4">
            Collections
          </h1>
          {/* <p className="max-w-lg mt-10 sm:max-w-xl md:max-w-2xl lg:max-w-4xl font-light mx-auto text-lg sm:text-xl md:text-2xl">
            Lorem ipsum dolor sit amet consectetur. Commodo vulputate malesuada
            lectus phasellus at turpis ac. Aenean etiam in volutpat risus eu
            metus eros turpis. Quis sit nulla augue velit. Lorem ipsum dolor sit
            amet consectetur. Commodo vulputate malesuada lectus phasellus at
            turpis ac. Aenean etiam in volutpat risus eu metus eros turpis. Quis
            sit nulla augue velit.
          </p> */}
        </div>
        <div className="absolute top-0 left-0 w-full h-full border-l-[1px] border-b-[3px] border-white z-30"></div>
      </section>
      {loading ? (
        <Loading /> // Display the Loading component while loading is true
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4 md:px-12 lg:px-48 py-20">
          {collection.map((col) => (
            <div className="relative overflow-hidden rounded-lg shadow-lg"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              <a
                href={`/shop/${col._id}/artworks`}
                className="relative overflow-hidden rounded-lg shadow-lg group"
              >
                <img
                  src={`${col.image}`}
                  alt={col.name}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute bottom-4 left-4 text-white p-5" data-aos="fade-in" data-aos-duration="1000">
                  <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                    {col.name}
                  </h3>
                  <button className="custom-button-black">View Collection</button>
                </div>
              </a>
            </div>
          ))}
        </div>)}
      <Footer />
    </div>
  );
};

export default Collections;
